import { CarFeaturedTileProps, CarTileProps, CarVideoTileProps } from "../types";
import { useState } from "react";
import CarTile from "./carTile";
import CarVideoTile from "./carVideoTile";

const CarFeaturedTile = ({
  videoSource,
  make,
  model,
  cashText,
  carImageSource,
  logoImageSource,
  saleTicketPrice,
  baseTicketPrice,
  baseTicketPriceWithoutCurrency,
  currencySymbol,
  discountPercentage,
  maxTicketsPerUser,
  overrideDiscount,
  saleTicketPriceWithoutCurrency,
  competitionId,
  prizeId,
  hideCashAlternative,
}: CarFeaturedTileProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const carTileProps: CarTileProps = {
    make,
    model,
    cashText,
    carImageSource,
    logoImageSource,
    saleTicketPrice,
    baseTicketPrice,
    baseTicketPriceWithoutCurrency,
    currencySymbol,
    discountPercentage,
    maxTicketsPerUser,
    overrideDiscount,
    saleTicketPriceWithoutCurrency,
    competitionId,
    prizeId,
    hideCashAlternative,
  };
  const carVideoTileProps: CarVideoTileProps = {
    videoSource,
    make,
    model,
    cashText,
    logoImageSource,
    saleTicketPrice,
    baseTicketPrice,
    baseTicketPriceWithoutCurrency,
    carImageSource,
    competitionId,
    currencySymbol,
    discountPercentage,
    maxTicketsPerUser,
    overrideDiscount,
    prizeId,
    saleTicketPriceWithoutCurrency,
    hideCashAlternative,
  };
  return (
    <div className="relative" onMouseOver={() => setIsHovered(true)} onMouseOut={() => setIsHovered(false)}>
      {/* Keep CarVideoTile mounted at all times so the video element is never destroyed.
          Destroying it on hover-out causes the browser to re-fetch the video file from scratch
          every time the user moves their mouse away, resulting in the same MP4 being downloaded
          multiple times per page load. CSS hidden preserves the element without re-downloading. */}
      <div className={isHovered ? "hidden" : ""}>
        <CarVideoTile {...carVideoTileProps} />
      </div>
      {isHovered && <CarTile {...carTileProps} />}
    </div>
  );
};

export default CarFeaturedTile;
